<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>坐席管理</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-button @click="getData" class="c-m-l-10" type="primary">刷新坐席状态</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          v-if="extFields.length > 0"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <c-table :fields="extFields">
            <template slot="agentState">
              <el-table-column label="坐席当前状态" width="200">
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.exts"
                    size="medium"
                    :effect="
                      scope.row.exts.agentState == -1 ||
                      scope.row.exts.agentState == 1 ||
                      scope.row.exts.agentState == 0
                        ? 'dark'
                        : 'plain'
                    "
                    :type="
                      scope.row.exts.agentState == -1
                        ? 'info'
                        : scope.row.exts.agentState == 1
                        ? 'success'
                        : scope.row.exts.agentState == 0
                        ? 'warning'
                        : ''
                    "
                  >
                    {{ osg.codelabel('agentState', scope.row.exts.agentState) }}
                  </el-tag>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column label="切换坐席状态" width="200">
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
                v-if="scope.row.exts.agentState != 1 && scope.row.exts.agentState != -1"
                @click="updateSobotAgentFree(scope.row._id)"
              >
                改为空闲
              </el-button>
              <el-button
                type="warning"
                size="mini"
                v-if="scope.row.exts.agentState != 0 && scope.row.exts.agentState != -1"
                @click="updateSobotAgentBusy(scope.row._id)"
              >
                改为忙碌
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination" layout="total" :total="fpi.total"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    window.$this = this;
    return {
      name: 'sobotAgent',
      fpi: { data: [] },
      extFields: [],
      extField: {},
      options: {
        codecfg_agentState: { codeId: 'agentState' }
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      }
    };
  },
  mounted() {
    this.osg.getFields('sobotAgent', () => {
      this.getData();
    });
  },
  methods: {
    getData() {
      this.osg.ajax('basic/sobot/querySobotAgents.do', {}, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    // 设置智齿客服人员状态为忙碌
    updateSobotAgentBusy(id) {
      this.osg.ajax('basic/sobot/updateSobotAgentBusy.do', { id }, () => {
        this.getData();
        this.osg.toast('坐席状态切换成功');
      });
    },
    // 设置智齿客服人员状态为空闲
    updateSobotAgentFree(id) {
      this.osg.ajax('basic/sobot/updateSobotAgentFree.do', { id }, () => {
        this.getData();
        this.osg.toast('坐席状态切换成功');
      });
    }
  }
};
</script>
